module.exports = __webpack_public_path__ + "images/category_lp/audio_instrument/new/store_images/3@2x_984a61cccdca41e3eea16359b25f8931.png";